import { render, staticRenderFns } from "./ResultsWithMixin.vue?vue&type=template&id=34e848f1"
import script from "./ResultsWithMixin.vue?vue&type=script&lang=js"
export * from "./ResultsWithMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports